import React from 'react'
import { withRouter } from 'react-router-dom'
import { Table, Button, TimePicker, Space, Modal, Input, message } from 'antd'
import Popconfirm from '../../components/Popconfirm/Popconfirm2'
import { getClubAllShift, addShift, deleteShift } from '../../api/employee'
import moment from 'moment'

class ClubEmployeeManager extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      isLoading: false, //加载
      shiftList: [], //班次列表数据
      visible: false, //弹窗
      action: '-1', //-1,1
      shiftId: -1, //id
      name: '', //班次名称
      times: [], //班次时间
      startTime: '',
      endTime: '',
    }
  }
  //显示修改页面
  onShowModal = (record) => {
    this.setState({
      visible: true,
      action: '1',
      name: record.name,
      shiftId: record.id,
      // times: [
      //   moment(record.startTime, 'HH:mm:ss'),
      //   moment(record.endTime, 'HH:mm:ss'),
      // ],
      startTime: moment(record.startTime, 'HH:mm'),
      endTime: moment(record.endTime, 'HH:mm'),
    })
  }
  /*
  显示添加界面
   */
  showAdd = () => {
    this.setState({
      visible: true,
      action: '-1',
      times: [],
      name: '',
      shiftId: -1,
      startTime: '',
      endTime: '',
    })
  }
  componentDidMount() {
    this.getShiftList()
  }
  //获取班次列表
  getShiftList = async () => {
    this.setState({ isLoading: true })
    const res = await getClubAllShift()
    const { data } = res
    const shiftList = data
    this.setState({
      isLoading: false,
      shiftList: data,
    })
  }
  //新增或编辑
  handleOk = async () => {
    this.setState({ isLoading: true })
    const { name, times, action, startTime, endTime } = this.state
    // const st = moment(times[0]).format('HH:mm:ss')
    // const et = moment(times[1]).format('HH:mm:ss')
    let listData = {
      name,
      startTime: moment(startTime).format('HH:mm'),
      endTime: moment(endTime).format('HH:mm'),
      shiftId: this.state.shiftId ? this.state.shiftId : -1,
    }
    if (name == '') {
      message.error('请输入班次名称')
    } else if (startTime == '' || endTime == '') {
      message.error('请输入时间名称')
    } else {
      const result = await addShift(listData)
      if (result.status == 1) {
        message.success(`${action == '1' ? '修改' : '添加'}成功`)
      } else {
        message.error(result.detail)
      }
      this.getShiftList()
      this.setState({ visible: false, isLoading: false })
    }
    // console.log(listData)
    // return
    // const result = await addShift(listData)
    // if (result.status == 1) {
    //   message.success(`${action == '1' ? '修改此数据' : '添加班次'}成功`)
    //   this.getShiftList()
    // }
    // this.setState({ visible: false, isLoading: false })
  }

  //删除班次时间
  deleteEmployee = async (id) => {
    const { status, detail, data } = await deleteShift(id)
    if (status != 1) {
      message.error(detail)
    }
    this.getShiftList()
    // const res = await deleteShift(id)
    // if (res.status === 1) {
    //   message.success(`删除${this.state.name}班次成功`)
    //   this.getShiftList()
    // }
    this.setState({ visible: false, isLoading: false })
  }

  /*
  取消
   */
  handleCancel = () => {
    this.setState({ visible: false })
  }
  /*
  获取input内容
   */
  getInputValaue = (value) => {
    this.setState({ name: value.target.value })
  }

  //获取上，下班时间
  handleChangeStartTime = (time, timeString) => {
    this.setState({
      startTime: time,
    })
  }

  //获取上，下班时间
  handleChangeEndTime = (time, timeString) => {
    this.setState({
      endTime: time,
    })
  }

  render() {
    const {
      shiftList,
      isLoading,
      action,
      visible,
      times,
      name,
      startTime,
      endTime,
    } = this.state
    const columns = [
      {
        title: '班次列表',
        dataIndex: 'name',
        key: 'name',
      },
      {
        title: '班次时间',
        dataIndex: 'time',
        key: 'time',
        render: (_, record) => {
          return (
            <span>
              {record.startTime}-{record.endTime}
            </span>
          )
        },
      },
      {
        title: '操作',
        dataIndex: 'edit',
        key: 'edit',
        render: (text, record, index) => {
          return (
            <div style={{ color: '#108EE9', cursor: 'default' }}>
              <Button
                type="primary"
                style={{ marginRight: '10px' }}
                onClick={() => this.onShowModal(record)}
              >
                编辑
              </Button>
              <Popconfirm
                title="你确认要删除此班次吗?"
                okText="确认"
                cancelText="取消"
                onConfirm={() => this.deleteEmployee(record.id)}
              >
                <Button type="primary" danger>
                  删除
                </Button>
              </Popconfirm>
            </div>
          )
        },
      },
    ]
    return (
      <div>
        <div style={{ marginBottom: '10px' }}>
          <Button type="primary" onClick={() => this.showAdd()}>
            新增班次
          </Button>
        </div>
        <Table
          loading={isLoading}
          dataSource={shiftList}
          columns={columns}
          rowKey="id"
        />
        {this.state.visible && (
          <Modal
            title={action === '-1' ? '新增班次' : '编辑班次'}
            visible={visible}
            onOk={this.handleOk}
            onCancel={this.handleCancel}
            width="700px"
          >
            <div style={{ textAlign: 'center', marginBottom: '2rem' }}>
              <div style={{ marginTop: '1rem' }}>
                <span className="info-span">名称:</span>
                <Input
                  size="middle"
                  style={{ width: '50%', marginLeft: '1rem' }}
                  defaultValue={name}
                  placeholder="请输入名称"
                  onChange={(value) => this.getInputValaue(value)}
                />
              </div>
            </div>
            <div style={{ textAlign: 'center', marginBottom: '2rem' }}>
              <div style={{ marginTop: '1rem' }}>
                <span className="info-span">时间:</span>
                <Space direction="vertical" style={{ width: '52%' }}>
                  <div className="time_box">
                    <TimePicker
                      format="HH:mm"
                      defaultValue={startTime}
                      onChange={this.handleChangeStartTime}
                      status="warning"
                      style={{
                        width: '38%',
                        marginLeft: '1rem',
                        marginRight: '1rem',
                      }}
                    />
                    到
                    <TimePicker
                      format="HH:mm"
                      defaultValue={endTime}
                      onChange={this.handleChangeEndTime}
                      status="warning"
                      style={{ width: '40%', marginLeft: '1rem' }}
                    />
                  </div>
                </Space>
              </div>
            </div>
          </Modal>
        )}
      </div>
    )
  }
}

export default withRouter(ClubEmployeeManager)



// WEBPACK FOOTER //
// ./src/containers/ClubShiftsSetting/index.js